<!-- https://primefaces.org/primeng/showcase/#/setup -->

<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!-- 		 	 -->
<!-- LOCK TO TOP -->
<!-- 			 -->
<div class="lock-to-top" style="background-color: #ffffff">
	<!-- 		 	   -->
	<!-- Date Selector -->
	<!-- 	  		   -->
	<div class="date-body">
		<div class="selector-body">
			<!-- 				 	-->
			<!-- DateRange Selector -->
			<!-- 				 	-->
			<div class="selector-item">
				<div>
					<label>Date Range</label>
				</div>

				<div style="margin-left: 10px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="DateRangeSelector"
						style="font-size: smaller"
						[(ngModel)]="SelectedDateRange"
						(ngModelChange)="onDateRangeChange($event)"
					>
						<option *ngFor="let r of lstDateRange" [ngValue]="r">
							{{ r.DateRangeDesc }}
						</option>
					</select>
				</div>
			</div>

			<!-- 			-->
			<!-- Start Date -->
			<!-- 			-->
			<div class="selector-item" [style.display]="this.SelectedDateRange.DateRangeID == 6 ? 'flex' : 'none'">
				<div>
					<label>Start Date</label>
				</div>

				<div style="margin-left: 10px">
					<p-calendar
						[style]="{ width: '100%' }"
						[inputStyle]="{ width: '100%' }"
						[(ngModel)]="rStartDate"
						(ngModelChange)="onStartDateChange($event)"
						[showTime]="false"
						hourFormat="12"
						showIcon="true"
						inputId="startdate"
					></p-calendar>
				</div>
			</div>

			<!-- 			-->
			<!-- End Date -->
			<!-- 			-->
			<div class="selector-item" [style.display]="this.SelectedDateRange.DateRangeID == 6 ? 'flex' : 'none'">
				<div>
					<label>End Date</label>
				</div>

				<div style="margin-left: 10px">
					<p-calendar
						[style]="{ width: '100%' }"
						[inputStyle]="{ width: '100%' }"
						[(ngModel)]="rEndDate"
						(ngModelChange)="onEndDateChange($event)"
						[showTime]="false"
						hourFormat="12"
						showIcon="true"
						inputId="enddate"
					></p-calendar>
				</div>
			</div>
		</div>
	</div>

	<!--				-->
	<!-- Error Message  -->
	<!--				-->
	<div class="error-group" [style.display]="ErrorMessage.length == 0 ? 'none' : 'block'">
		<div class="error-div">
			<label class="error-message">{{ ErrorMessage }}</label>
		</div>
	</div>

	<!--		-->
	<!-- Totals -->
	<!--		-->
	<div class="total-body">
		<div style="margin-left: 20px; margin-right: 20px">
			<div class="total-row">
				<div style="margin-left: 0px">
					<label class="total-row-label">Present:</label>
					<label class="total-row-count">{{ rDRPresent }}</label>
					<label class="total-row-pct">({{ rDRPresentPCT | number : "1.0-2" }}%)</label>
				</div>

				<div style="margin-left: 5px">
					<label class="total-row-label">Absences:</label>
					<label class="total-row-count">{{ rDRAbsent }}</label>
					<label class="total-row-pct">({{ rDRAbsentPCT | number : "1.0-2" }}%)</label>
				</div>

				<div style="margin-left: 5px">
					<label class="total-row-label">On Time:</label>
					<label class="total-row-count">{{ rDROnTime }}</label>
					<label class="total-row-pct">({{ rDROnTimePCT | number : "1.0-2" }}%)</label>
				</div>

				<div style="margin-left: 5px">
					<label class="total-row-label">Tardies:</label>
					<label class="total-row-count">{{ rDRTardy }}</label>
					<label class="total-row-pct">({{ rDRTardyPCT | number : "1.0-2" }}%)</label>
				</div>
			</div>

			<div class="total-row">
				<div style="margin-left: 0px">
					<label class="total-row-label">Total Days:</label>
					<label class="total-row-count">{{ rDRTotalDays }}</label>
					<label class="total-row-pct"></label>
				</div>

				<div style="margin-left: 5px">
					<label class="total-row-label">Suspensions:</label>
					<label class="total-row-count">{{ rDRSuspension }}</label>
					<label class="total-row-pct"></label>
				</div>

				<div style="margin-left: 5px">
					<label class="total-row-label">Class Cuts:</label>
					<label class="total-row-count">{{ rDRCut }}</label>
					<label class="total-row-pct"></label>
				</div>
			</div>
		</div>
	</div>

	<!-- 		 -->
	<!-- Buttons -->
	<!-- 		 -->
	<div class="button-body">
		<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>
		<button
			*ngIf="rInited == true && rSBMEnabledSchool == true && rUserHasSBMRole == true"
			class="btn btn-success"
			style="margin-left: 5px"
			(click)="onAddSBMIncident()"
		>
			Add SBM Incident
		</button>
		<button *ngIf="rInited == true && rSBMEnabledSchool == false" class="btn btn-success" style="margin-left: 5px" (click)="onEditBasic()">
			Edit Basic
		</button>
		<button *ngIf="rInited == true && rSBMEnabledSchool == false" class="btn btn-success" style="margin-left: 5px" (click)="onAddBasic()">Add Basic</button>
		<button
			*ngIf="rInited == true && rSBMEnabledSchool == false"
			class="btn btn-primary"
			style="margin-left: 5px"
			(click)="onEditAdvanced()"
			[disabled]="rEnableAdvancedMode == false"
		>
			Edit Advanced
		</button>
		<button
			*ngIf="rInited == true && rSBMEnabledSchool == false"
			class="btn btn-primary"
			style="margin-left: 5px"
			(click)="onAddAdvanced()"
			[disabled]="rEnableAdvancedMode == false"
		>
			Add Advanced
		</button>
		<button *ngIf="rInited == true && rSBMEnabledSchool == false" class="btn btn-danger" style="margin-left: 5px" (click)="onDelete()">Delete</button>
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onPrint()">Print</button>
		<img class="info-img" (click)="onToggleInfo()" src="assets/images/info-24.png" />

		<div>
			<!-- 				   -->
			<!-- Display When Busy -->
			<!-- 				   -->
			<div [style.display]="isBusy == true ? 'block' : 'none'" style="width: 20px">
				<img class="busy-img" src="assets/images/loading.gif" />
			</div>
			<div [style.display]="isBusy == false ? 'block' : 'none'" style="width: 20px"></div>
		</div>
	</div>

	<div style="padding: 20px; padding-top: 0px; background-color: #ebebeb" [style.display]="isShowInfo == true ? 'block' : 'none'">
		<label>&#9900; Total Discipline records for date range: {{ lstIncident.length }}</label
		><br />
		<label>&#9900; All counts and percentages are for the date range entered</label><br />
		<label>&#9900; Edit Basic - To edit discipline using basic mode.</label><br />
		<label>&#9900; Add Basic - To add discipline using basic mode.</label><br />
		<label>&#9900; Edit Advanced - To edit discipline using advanced mode. (If Enabled)</label><br />
		<label>&#9900; Add Advanced - To add discipline using advanced mode. (If Enabled)</label><br />
		<label>&#9900; Print - Prints 1 of 2 reports for the date range entered.</label><br />
		<label>&#9900; When Infraction Description is bold*, then more than one infraction is attached to the discipline using advanced mode.</label><br />
		<label>&#9900; When Action Description is bold*, then more than one action is attached to the discipline using advanced mode.</label><br />
		<label>&#9900; +Alert indicates a discipline with an active alert</label><br />
		<label>&#9900; Use ctl to add a column to the sort selection</label><br />
	</div>
</div>

<div *ngIf="rInited == true && rSBMEnabledSchool == true" class="alert alert-info" style="margin-top: 5px">Please use SBM to create and manage incidents</div>

<!-- 				  	      -->
<!-- Display Incident Items -->
<!-- 					      -->
<div class="table-main-body">
	<!-- Note: resizableColumns breaks the multiline ability -->

	<p-table
		#mydt
		[value]="lstIncident"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedIncident"
		dataKey="IncidentID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[10, 25, 50]"
	>
		<ng-template pTemplate="header">
			<!-- 				-->
			<!-- Filter Section -->
			<!-- 				-->
			<tr>
				<th class="fixwidth-12">
					<p-columnFilter type="text" field="SchoolNumber" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<th><!-- IncidentDT Placeholder --></th>

				<th>
					<p-columnFilter type="text" field="InfractionDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<th>
					<p-columnFilter type="text" field="PenaltyDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<th>
					<p-columnFilter type="text" field="Message" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<th class="fixwidth-09"><!-- StartDate Placeholder --></th>

				<th class="fixwidth-09"><!-- EndDate Placeholder --></th>

				<th class="fixwidth-12">
					<p-columnFilter field="ContinueAlertDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterContinueAlertDesc
								[ngModel]="value"
								[options]="lstContinueAlertDescs"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!-- 			  -->
			<!-- Sort Section -->
			<!-- 			  -->
			<tr style="height: 4rem">
				<th pSortableColumn="SchoolNumber" class="fixwidth-12">School#<p-sortIcon field="SchoolNumber"></p-sortIcon></th>
				<th pSortableColumn="IncidentDT">Date / Time<p-sortIcon field="IncidentDT"></p-sortIcon></th>
				<th pSortableColumn="InfractionDesc">Infraction<p-sortIcon field="InfractionDesc"></p-sortIcon></th>
				<th pSortableColumn="PenaltyDesc">Action<p-sortIcon field="PenaltyDesc"></p-sortIcon></th>
				<th pSortableColumn="Message">Alert Message<p-sortIcon field="Message"></p-sortIcon></th>
				<th pSortableColumn="StartDate" class="fixwidth-09">Start Date<p-sortIcon field="StartDate"></p-sortIcon></th>
				<th pSortableColumn="EndDate" class="fixwidth-09">End Date<p-sortIcon field="EndDate"></p-sortIcon></th>
				<th pSortableColumn="ContinueAlert" class="fixwidth-12">+Alert<p-sortIcon field="ContinueAlert"></p-sortIcon></th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-rIncidentItem>
			<tr [pSelectableRow]="rIncidentItem" (dblclick)="onRowDblClick(rIncidentItem)">
				<td>
					<div class="fixwidth-12">
						{{ rIncidentItem.SchoolNumber }}
					</div>
				</td>

				<td>
					<div>
						{{ rIncidentItem.IncidentDT | date : "MMM d, y, h:mm a" }}
					</div>
				</td>

				<td>
					<div
						class="table-data-desc"
						[ngClass]="{
							'table-color-desc-1': rIncidentItem.InfractionCount <= 1,
							'table-color-desc-2': rIncidentItem.InfractionCount > 1
						}"
					>
						{{ rIncidentItem.InfractionDesc }}
					</div>
				</td>

				<td>
					<div
						class="table-data-desc"
						[ngClass]="{
							'table-color-desc-1': rIncidentItem.PenaltyCount <= 1,
							'table-color-desc-2': rIncidentItem.PenaltyCount > 1
						}"
					>
						{{ rIncidentItem.PenaltyDesc }}
					</div>
				</td>

				<td>
					<div class="table-data-desc" style="font-weight: bold" [ngStyle]="{ color: rIncidentItem.FontColor }">
						{{ rIncidentItem.Message }}
					</div>
				</td>

				<td>
					<div>
						{{ rIncidentItem.StartDate | date : "MMM d, y" }}
					</div>
				</td>

				<td>
					<div>
						{{ rIncidentItem.EndDate | date : "MMM d, y" }}
					</div>
				</td>

				<td>
					<div class="fixwidth-09">
						<i
							class="pi"
							[ngClass]="{
								'pi-check-circle table-active': rIncidentItem.ContinueAlert,
								'pi-ban table-inactive': !rIncidentItem.ContinueAlert
							}"
						></i>
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!-- 						  -->
<!-- Display When No Location -->
<!-- 					      -->
<div style="padding: 20px" [style.display]="lstIncident.length < 1 && isBusy == false ? 'block' : 'none'">
	<label>No discipline records for date range...</label>
</div>
